export default __webpack_public_path__ + "static/media/BM_RenderCamera_12_BedroomC+Interior+Light_Scheme+Bedroom.0af62270.jpg";